import {
  getComponentCssUrl,
  getGlobalCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavHeaderUtilityTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavHeaderUtility--wc.css')}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplateNavHeaderUtilityStyles = () => createNavHeaderUtilityTemplate()
export { getTemplateNavHeaderUtilityStyles }
